import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Combos/getComboLineaGenetica`, method: 'GET', body: null, token: token})
}